module.exports = __webpack_public_path__ + "static/media/alerts_icon_blue.552dfe0e.png";